import React, { Component } from 'react';

import "./Readmore-Articles.scss"
import ArticleItem from "../Readmore-ArticleItem/Readmore-ArticleItem"

class ReadmoreArticles extends Component {
    constructor() {
        super();
        this.state = {}
    }
    getItems() {
        return this.props.articles.list.map((item, index) =>
            <ArticleItem key={index.toString()} item={item} />
        );
    }
    render() {
        return (
            <div className="articles">
                <div className="padding">
                    <div className="headline">
                        <div className="line right"></div>
                        <h4>{this.props.articles.headline}</h4>
                        <div className="line left"></div>
                    </div>
                    <div className="container">
                        <ul>
                            {this.getItems()}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReadmoreArticles;



// WEBPACK FOOTER //
// ./src/components/Readmore/components/Readmore-Articles/Readmore-Articles.js